import { stats } from '@fiverr-private/obs';
import LocalStorage from '../../services/LocalStorage';
import { HELPFUL_STORAGE_KEY, HELPFUL_STATS_PREFIX, ON, OFF, STATS_PREFIX } from '../../constants';
import { reportHelpfulEvent } from '../../utils/reports/helpful';
import { UPDATE_THUMBS_SELECTED } from './types';

const updateLocalStorage = ({ id, thumbUpSelected, thumbDownSelected }) => {
    const helpful = LocalStorage.get(HELPFUL_STORAGE_KEY);
    const updatedHelpful = {
        ...helpful,
        [id]: {
            thumbUp: thumbUpSelected,
            thumbDown: thumbDownSelected,
        },
    };
    LocalStorage.set(HELPFUL_STORAGE_KEY, updatedHelpful);
};

export const updateSelectedThumbs =
    ({ id, thumbUpSelected, thumbDownSelected }) =>
    (dispatch) => {
        updateLocalStorage({ id, thumbUpSelected, thumbDownSelected });
        dispatch({
            type: UPDATE_THUMBS_SELECTED,
            id,
            value: {
                thumbUp: thumbUpSelected,
                thumbDown: thumbDownSelected,
            },
        });
    };

export const reportHelpfulClickEvent =
    ({ id, encryptedOrderId, type, value }) =>
    (dispatch, { user_id, gig_id, studio_id, pageCtxId, pageName }) => {
        const eventData = {
            reviewId: id,
            encryptedOrderId,
            state: value ? ON : OFF,
            sellerId: user_id,
            gigId: gig_id,
            studioId: studio_id,
            pageCtxId,
            pageName,
        };
        reportHelpfulEvent(type, eventData);
    };

export const graphHelpfulEvent =
    ({ type, value }) =>
    (dispatch) => {
        const state = value ? ON : OFF;

        stats.count(STATS_PREFIX, `${HELPFUL_STATS_PREFIX}.${type}.${state}`);
        dispatch({ type });
    };
